import { render } from "./CompaniaEmailsDestinatarios.vue?vue&type=template&id=09bca29e&scoped=true"
import script from "./CompaniaEmailsDestinatarios.vue?vue&type=script&lang=js"
export * from "./CompaniaEmailsDestinatarios.vue?vue&type=script&lang=js"

import "./CompaniaEmailsDestinatarios.vue?vue&type=style&index=0&id=09bca29e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bca29e"]])

export default __exports__